// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pboA","toggleWrap":"styles_toggleWrap__rwd0m","content":"styles_content__3BsoA","selectAreaCode":"styles_selectAreaCode__3WNcx"};